<template>
  <modal
    ref="modal"
    :width="300"
    :height="400"
    :click-to-close="false"
    name="create-password-modal"
    class="create-password-modal"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <div class="close-icon-container" @click="closeCreatePasswordModal">
      <span class="icon">
        <img
          src="~/assets/images/icons/Close-button.svg"
          class="icon alt"
          alt="close icon"
        />
      </span>
    </div>
    <CongratsMessage />
    <CreatePassword v-if="!$store.getters['user/user']" />
  </modal>
</template>

<script>
import CreatePassword from '@/components/auth/CreatePassword'
import CongratsMessage from '@/components/common/CongratsMessage'

export default {
  name: 'CreatePasswordModal',
  components: { CreatePassword, CongratsMessage },
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {
    beforeOpen(event) {},
    beforeClose(event) {},
    closeCreatePasswordModal() {
      this.$modal.hide('create-password-modal')
      this.$router.replace(`/dashboard`)
    },
  },
}
</script>

<style lang="scss">
.create-password-modal {
  .close-icon-container {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }
  .v--modal-box {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    @include tablet {
      padding: 50px;
    }
  }
}
</style>
